/* eslint-disable no-unused-vars */
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  collapsible: {},
  collapsibleToggle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    gap: 'var(--ui-spacer-m)',
    padding: 'var(--ui-spacer-m) 0',
  },
  collapsibleToggleIcon: {
    transform: 'rotate(-0.01deg)',
    transition: 'transform 0.25s ease-in-out',
    flexShrink: 0,
    width: '1.8rem',
    height: 'auto',
  },
  collapsibleToggleIconOpen: {
    transform: 'rotate(180deg)',
    transition: 'transform 0.25s ease-in-out',
  },
  collapsibleContent: {
    maxHeight: '0px',
    overflow: 'hidden',
    transition: 'max-height 0.25s ease-in-out',
  },
  collapsibleContentOpen: {
    overflowY: 'auto',
    transition: 'max-height 0.5s ease-in-out',
  },
  title: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    lineHeight: 1.25,
    flex: 1,
  },
}))

export default useStyles
